import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Layout = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen bg-canvas">
      <Header />
      <main className="pt-16">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
};
